export default class Timer {
    constructor(total, callback) {
        this.timer = 0;
        this.timeTracker = 0;
        this.total = total;
        this.frameLength = 100;
        this.callback = callback;
    }

    start() {
        if (this.timer === 0) {
            this.timer = setInterval(this.countDown.bind(this), this.frameLength);
        }
    }

    isRunning() {
        return this.timer !== 0;
    }

    restart() {
        this.timeTracker = 0;
    }

    countDown() {
        this.timeTracker += this.frameLength;

        if (this.timeTracker >= this.total) {
            clearInterval(this.timer);
            this.timer = 0;
            this.callback();
        }
    }
}




// WEBPACK FOOTER //
// ./src/helpers/Timer.js